/**
 * @desc 启用/禁用
 */
const URL = "/rantion-basics";
import http, { updateResponse } from "@/http";
export type Response = defs.basics.Response;
export function request(
  body: defs.basics.SysGlobalParamChangeStatusRequestDto,
  options?: any,
): Promise<Response> {
  return updateResponse(
    http(URL + `/basics/sysGlobalParam/changeStatus`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
